import React from 'react';
import styled from 'styled-components';

const Image = styled.img`
  cursor: pointer;
`;

interface CommonImageIProps {
  src: any;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const CommonImage: React.FC<CommonImageIProps> = props => {
  const { src, style, onClick } = props;

  const handleClick = (e: React.MouseEvent<HTMLImageElement>) => {
    if (onClick) {
      e.stopPropagation();

      onClick();

      return;
    }

    return;
  };

  return (
    <Image
      src={src}
      alt={`icon ${src}`}
      onClick={handleClick}
      style={{ ...style }}
    />
  );
};

export default CommonImage;
